import { inject, Injectable } from '@angular/core';
import { Observable }         from 'rxjs';

import { RestService } from '../../core/rest.service';
import { environment } from '../../../environments/environment';

export interface InvitationData {
  accountOwnerUsername?: string;
  agentEmail: string;
  accountIds: number[];
  customerIds?: number[];
  bankId?: number;
  customerId?: number;
  creationTime?: number;
  inviterPortalUsername?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShareAccessService {
  private restService = inject(RestService);


  shareAccess(invitationData: InvitationData): Observable<void> {
    return this.restService.post<void>(
      environment.api.endpoints.sendInvitation, {
        agentEmail: invitationData.agentEmail,
        accountIds: invitationData.accountIds
      });
  }
}
